import type StudySlideModel from '../../../models/StudySlideModel';
import { requestAndParse, requestSuccessful } from '../request';

const getStudySlides = async (studyId?: number) => {
    const route = 'admin/get-study-slides';
    const payload = { studyId };

    const response = await requestAndParse(route, payload, 'GET');

    const success = requestSuccessful(response);
    const slides = (response.body?.slides ?? []) as StudySlideModel[];

    return { success, slides };
};

export default getStudySlides;
